import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useNavigate } from "react-router-dom";
import { messages } from "./messages.i18n";
import { PATHS } from "@constants/Paths";
import { AppHeader } from "@components/app-header";
import { RefetchProvider, useDebounce } from "@piiqtechnologies/ui-lib";
import { PeekBox, PeekGrid, PeekPaper, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import TabsLayout from "@layouts/tabs";
import { AddNewRequestButton, FilterDatesButton, ScheduleButton, } from "@components/scan-requests";
import SearchText from "@components/common/search-text";
export var SCAN_TAB;
(function (SCAN_TAB) {
    SCAN_TAB["REQUESTS"] = "requests";
    SCAN_TAB["COMPLETED"] = "completed";
})(SCAN_TAB || (SCAN_TAB = {}));
export const AdminScanRequestsLayout = () => {
    const intl = useIntl();
    const theme = useTheme();
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [dateRange, setDateRange] = useState();
    const [isScheduleMode, setIsScheduleMode] = useState(false);
    const [selectedScanRequests, setSelectedScanRequests] = useState([]);
    const handleScheduleMode = (isScheduleMode) => {
        setSelectedScanRequests([]);
        setIsScheduleMode(isScheduleMode);
    };
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(null);
    const handleTabChange = (value) => {
        navigate(value);
    };
    const SCAN_REQUESTS_TABS = [
        {
            value: PATHS.SCAN_REQUESTS_ADMIN_REQUESTS,
            label: messages.adminScanRequestsTabRequests,
        },
        {
            value: PATHS.SCAN_REQUESTS_ADMIN_COMPLETED,
            label: messages.adminScanRequestsTabCompleted,
        },
    ];
    useEffect(() => {
        const sgtURLSegments = location.pathname.split("/");
        const activeTabURL = sgtURLSegments.pop() || sgtURLSegments.pop();
        const isValidTabValue = SCAN_REQUESTS_TABS.map(({ value }) => value).includes(activeTabURL);
        setTabValue((isValidTabValue && activeTabURL) || PATHS.SCAN_REQUESTS_ADMIN_REQUESTS);
    }, [location.pathname]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center", height: theme.spacing(4) },
                React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.adminScanRequestsPageTitle) }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekBox, { position: "relative" },
                React.createElement(PeekPaper, { sx: { p: theme.spacing(1.5) } },
                    React.createElement(RefetchProvider, null,
                        React.createElement(TabsLayout, { tabs: SCAN_REQUESTS_TABS, activeTab: tabValue, onTabChange: handleTabChange, TabContent: React.createElement(Outlet, { context: {
                                    searchKey: debouncedSearchKey,
                                    isScheduleMode: isScheduleMode,
                                    onSelectScanRequest: setSelectedScanRequests,
                                    isAdmin: true,
                                    dateRange: dateRange,
                                } }), TabAction: tabValue === SCAN_TAB.REQUESTS ? (React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1), maxWidth: "105%" },
                                React.createElement(ScheduleButton, { isTableScheduleMode: handleScheduleMode, selectedScanRequests: selectedScanRequests }),
                                React.createElement(AddNewRequestButton, null))) : (React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1), maxWidth: "55%" },
                                React.createElement(FilterDatesButton, { handleNewDateRange: (values) => setDateRange(values) }),
                                React.createElement(SearchText, { placeholder: intl.formatMessage(messages.scanRequestsCompletedSearch), searchText: searchKey, onChange: setSearchKey }))) })))))));
};
